import { Link, matchPath, useLocation } from 'react-router-dom';
import { config } from '../../config';
import { NotificationBadge } from '../notifications/NotificationBadge';
import { MeetInstruction } from '../../pages/meet/MeetInstruction';
import { RouletteInstruction } from '../../pages/roulette/RouletteInstruction';
import { FiltersCount } from '../../pages/meet/FiltersCount';
import { Button } from '../Button';
import { openTelegramLink } from '../../utils/openLink';
import { UsersRoundIcon } from 'lucide-react';

function StreamsTopBarActions() {
  const location = useLocation();

  return (
    <div className="flex gap-[8px] ml-auto">
      <Link to={`${config.ROUTES.STREAMS.FILTERS}${location.search}`}>
        <img alt="filters" src="/icons/Button-filters.svg" className="cursor-pointer" />
      </Link>

      <Link to={config.ROUTES.NOTIFICATIONS} className="relative">
        <img alt="notifications" src="/icons/Button-notifications.svg" className="w-[44px] h-[44px] cursor-pointer" />
        <NotificationBadge />
      </Link>
    </div>
  );
}

const configTopBar = {
  [config.ROUTES.CHATS.LIST]: {
    items: [
      () => (
        <button
          className="bg-[#A1F69E] text-sm font-medium px-3 py-2 rounded-full text-[#010D0D] flex items-center gap-2"
          onClick={() => openTelegramLink('https://t.me/mytadating')}
        >
          <img src="/icons/selfhst_telegram.svg" alt="Канал" className="w-[24px] h-[24px]" />
          КАНАЛ
        </button>
      ),
      () => (
        <Link to={config.ROUTES.NOTIFICATIONS} className="relative">
          <img alt="notifications" src="/icons/Button-notifications.svg" className="w-[44px] h-[44px] cursor-pointer" />
          <NotificationBadge />
        </Link>
      )
    ]
  },
  [config.ROUTES.NOTIFICATIONS]: {
    items: [
      () => (
        <button
          className="bg-[#A1F69E] text-sm font-medium px-3 py-2 rounded-full text-[#010D0D] flex items-center gap-2"
          onClick={() => openTelegramLink('https://t.me/mytadating')}
        >
          <img src="/icons/selfhst_telegram.svg" alt="Канал" className="w-[24px] h-[24px]" />
          КАНАЛ
        </button>
      ),
      () => (
        <Link to={config.ROUTES.NOTIFICATIONS} className="relative ml-auto">
          <img alt="notifications" src="/icons/Button-notifications.svg" className="w-[44px] h-[44px] cursor-pointer" />
          <NotificationBadge />
        </Link>
      )
    ]
  },
  [config.ROUTES.STREAMS.LIST]: {
    items: [
      () => (
        <button
          className="bg-[#A1F69E] text-sm font-medium px-3 py-2 rounded-full text-[#010D0D] flex items-center gap-2"
          onClick={() => openTelegramLink('https://t.me/mytadating')}
        >
          <img src="/icons/selfhst_telegram.svg" alt="Канал" className="w-[24px] h-[24px]" />
          КАНАЛ
        </button>
      ),
      () => <StreamsTopBarActions />
    ]
  },
  [config.ROUTES.ROULETTE]: {
    items: [
      () => (
        <button
          className="bg-[#A1F69E] text-sm font-medium px-3 py-2 rounded-full text-[#010D0D] flex items-center gap-2"
          onClick={() => openTelegramLink('https://t.me/mytadating')}
        >
          <img src="/icons/selfhst_telegram.svg" alt="Канал" className="w-[24px] h-[24px]" />
          КАНАЛ
        </button>
      ),
      () => (
        <div className="flex gap-[8px] ml-auto">
          <RouletteInstruction />

          <Link to={config.ROUTES.NOTIFICATIONS} className="relative">
            <img
              alt="notifications"
              src="/icons/Button-notifications.svg"
              className="w-[44px] h-[44px] cursor-pointer"
            />
            <NotificationBadge />
          </Link>
        </div>
      )
    ]
  },
  [config.ROUTES.MEET]: {
    items: [
      () => (
        <button
          className="bg-[#A1F69E] text-sm font-medium px-3 py-2 rounded-full text-[#010D0D] flex items-center gap-2"
          onClick={() => openTelegramLink('https://t.me/mytadating')}
        >
          <img src="/icons/selfhst_telegram.svg" alt="Канал" className="w-[24px] h-[24px]" />
          КАНАЛ
        </button>
      ),
      () => (
        <div className="flex gap-[8px] ml-auto">
          <FiltersCount />

          <MeetInstruction />

          <Link to={config.ROUTES.NOTIFICATIONS} className="relative">
            <img
              alt="notifications"
              src="/icons/Button-notifications.svg"
              className="w-[44px] h-[44px] cursor-pointer"
            />
            <NotificationBadge />
          </Link>
        </div>
      )
    ]
  },
  [config.ROUTES.SUBSCRIPTION.MAIN]: {
    items: [
      () => (
        <Link to={config.ROUTES.PROFILE_MENU}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </Link>
      ),
      () => <p className="flex-1 text-center my-auto gap-[8px] text-2xl text-white">Управление подпиской</p>
    ]
  },
  [config.ROUTES.PROFILE_MENU]: {
    items: [
      () => (
        <Link to={config.ROUTES.MEET}>
          <img alt="back" src="/icons/Button-close.svg" className="w-[44px] h-[44px]" />
        </Link>
      ),
      () => <p className="flex-1 text-center my-auto gap-[8px] text-2xl text-white">Меню</p>
    ]
  }
};

export function TopBar() {
  const location = useLocation();

  const activeTopBarRoute = Object.keys(configTopBar).find((route) => matchPath(route, location.pathname));

  if (!activeTopBarRoute) return;

  return (
    <div className="sticky z-10 top-0 left-0 right-0 flex justify-between gap-1 w-full px-4 pt-5 pb-4">
      {configTopBar[activeTopBarRoute].items.map((Item, index) => (
        <Item key={index} />
      ))}
    </div>
  );
}
